import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input } from "antd";
import ButtonWrapper from "../../../../views/components/reuseComp/ButtonWrapper";
import TextArea from "antd/es/input/TextArea";

interface GetInTouchProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  getInTouchData?: { heading?: string; subtext?: string };
  loading?: boolean;
}

const GetInTouch: React.FC<GetInTouchProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  getInTouchData,
  loading,
}) => {
  useEffect(() => {
    if (getInTouchData) {
      form.setFieldsValue({
        getInTouch: {
          heading: getInTouchData.heading || "",
          subtext: getInTouchData.subtext || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [getInTouchData, form]);

  console.log("getInTouchData", getInTouchData);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left text-sm md:text-base">
                    Heading
                  </th>
                  <th className="py-3 px-4 text-center text-sm md:text-base">
                    Subtext
                  </th>
                  <th className="py-3 px-4 text-end text-sm md:text-base ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {getInTouchData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 text-center">
                      {getInTouchData?.heading || "—"}
                    </td>
                    <td className="py-3 px-4 text-center">
                      {getInTouchData?.subtext || "—"}
                    </td>
                    <td className="py-3 px-4 h-full text-primary">
                      <div className="flex items-center justify-end gap-4 h-full">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="sm:hidden">
            {getInTouchData ? (
              <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Heading:
                  </span>
                  <p>{getInTouchData?.heading || "—"}</p>
                </div>
                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Subtext:
                  </span>
                  <p>{getInTouchData?.subtext || "—"}</p>
                </div>

                <div>
                  <span className="font-semibold text-primary block mt-2 mb-1">
                    Action:
                  </span>
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-black text-[18px]"
                  />
                </div>
              </div>
            ) : (
              <div className="bg-[#F9F9F9] border flex justify-center border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  {" "}
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["getInTouch", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading..." />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["getInTouch", "subtext"]}
                rules={[{ required: true, message: "Please enter subtext" }]}
              >
                <TextArea placeholder="Enter subtext..." />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetInTouch;
